/*
 * Fleet ve Fleet Statistics sayfalarındaki butonlara sayfa içi (#…) bağlantı
 * verilebiliyor: hero'nun ikincil butonu bölümlerin anchor_id ayarına iniyor.
 * Tarayıcının varsayılanı hedefe anında sıçramak; burada onu yumuşak
 * kaydırmaya çeviriyoruz.
 *
 * Tek dinleyici document üzerinde duruyor: bölümler dört ayrı dosya ve
 * tıklama hangisinden gelirse gelsin aynı davranış geçerli.
 */
(function () {
  /* Sabit header payı html'deki scroll-padding-top: var(--header-h) üzerinden
     geliyor; burada ayrıca ofset eklemek onu çift sayardı. */
  var SCOPE = '[data-fleet-anchors]';

  document.addEventListener('click', function (event) {
    /* Yeni sekmede açma ve benzeri niyetler tarayıcıya bırakılır. */
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
    if (!link || !link.closest(SCOPE)) return;

    var hash = link.getAttribute('href');
    /* Yer tutucu href="#" (linki girilmemiş kart/buton) dokunulmadan geçer. */
    if (!hash || hash.length < 2) return;

    var target;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return;
    }
    /* Hedef bu sayfada yoksa (merchant başka bir şablona bağlamış olabilir)
       tarayıcının kendi davranışı bozulmasın. */
    if (!target) return;

    event.preventDefault();

    /* scrollIntoView'in behavior seçeneği CSS'teki scroll-behavior'ı ezer,
       o yüzden azaltılmış hareket tercihini burada ayrıca soruyoruz. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

    /* Adres çubuğu ve geri tuşu normal bir çapa bağlantısıyla aynı davransın.
       pushState, hash atamasının aksine kaydırmayı tetiklemez — `location.hash`
       yazmak yumuşak kaydırmanın ortasında hedefe sıçratırdı.

       Yumuşak kaydırmadan sonra geri tuşu sayfanın başına değil hedefe
       dönüyor; bu tarayıcının kendi davranışı, `html { scroll-behavior:
       smooth }` ile kurulan native çapa bağlantısı da aynısını yapıyor. */
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', hash);
    }

    /* Odak da hedefe geçsin: taşınmazsa sonraki Tab, kaydırılan yerden değil
       butonun kaldığı yerden devam eder. preventScroll olmadan odaklanma
       yumuşak kaydırmayı kesip hedefe sıçratır. */
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      /* preventScroll desteklenmiyorsa odağı hiç taşımayız: sıçrama,
         kaydırmanın kendisini bozmaktan iyidir. */
    }
  });
})();
